import styled, { ThemeProps, DefaultTheme } from 'styled-components';
import { ISemanticLayerColors } from '../../styling';

/*
  Supported Layers
    1. Canvas - App Background
    2. Content - (Tabs Panel, Collapsible)
    2. Overlay -
    3. OverlayContent - Popup, Message Box, Callout, Flyout, Context Menu, Tooltip
    4. Input
 */

function selectLayersTheme(accessor: (theme: ISemanticLayerColors) => any) {
  return ({ theme }: ThemeProps<DefaultTheme>) => accessor(theme.semantics.colors.layers);
}

export const CanvasLayer = styled.div.attrs({ className: String('ap-canvasLayer') })`
  background-color: ${selectLayersTheme(t => t.canvasBackground)};
  color: ${selectLayersTheme(t => t.canvas)};
`;

export const ContentLayer = styled.div.attrs({ className: String('ap-contentLayer') })`
  background-color: ${selectLayersTheme(t => t.contentBackground)};
  color: ${selectLayersTheme(t => t.content)};
`;

export const OverlayLayer = styled.div.attrs({ className: String('ap-overlayLayer') })`
background-color: ${selectLayersTheme(t => t.overlayBackground)};
/* color: ${selectLayersTheme(t => t.overlay)}; */
`;

export const OverlayContentLayer = styled.div.attrs({ className: String('ap-overlayContentLayer') })`
background-color: ${selectLayersTheme(t => t.overlayContentBackground)};
/* color: ${selectLayersTheme(t => t.overlayContent)}; */
`;

// export const InputContentLayer = styled.div.attrs({ className: 'ap-inputLayer' })`
// background-color: ${selectLayersTheme(t => t.inputBackground)};
// color: ${selectLayersTheme(t => t.input)};
// `;
